import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import PremiumHero from './components/PremiumHero';
import PricingCards from './components/PricingCards';
import FeaturesTable from './components/FeaturesTable';
import PremiumTestimonials from './components/PremiumTestimonials';
import PremiumFAQ from './components/PremiumFAQ';
import PremiumFinalCTA from './components/PremiumFinalCTA';

const PremiumPage = () => {
  return (
    <div className="min-h-screen bg-[#05070d]">
      <Header />
      <main>
        <PremiumHero />
        <PricingCards />
        <FeaturesTable />
        <PremiumTestimonials />
        <PremiumFAQ />
        <PremiumFinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default PremiumPage;
